var _rect, _circle, _circle2, _circle3, _line, _path, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavSwConfigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 21.5,
    height: 18.5,
    rx: 3.25,
    stroke: "#6E7079",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3,
    r: 0.5,
    fill: "#6E7079"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 3,
    r: 0.5,
    fill: "#6E7079"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3,
    r: 0.5,
    fill: "#6E7079"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 5.25,
    x2: 22,
    y2: 5.25,
    stroke: "#6E7079",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4392 10.5029L15.1593 9.99714C14.9225 9.56923 14.3976 9.42161 13.986 9.66714V9.66714C13.7901 9.7873 13.5563 9.82139 13.3362 9.7619C13.116 9.7024 12.9277 9.55421 12.8127 9.35C12.7387 9.2202 12.6989 9.07236 12.6974 8.92143V8.92143C12.7041 8.67945 12.6164 8.44496 12.4543 8.27137C12.2922 8.09779 12.0695 7.9999 11.837 8H11.273C11.0451 8 10.8267 8.0945 10.666 8.26261C10.5053 8.43071 10.4156 8.65855 10.4167 8.89571V8.89571C10.4099 9.38538 10.0267 9.77862 9.55624 9.77857C9.41125 9.777 9.26923 9.73561 9.14455 9.65857V9.65857C8.73293 9.41304 8.20808 9.56066 7.97124 9.98857L7.67071 10.5029C7.43416 10.9302 7.57403 11.4763 7.98359 11.7243V11.7243C8.24981 11.8843 8.41381 12.18 8.41381 12.5C8.41381 12.82 8.24981 13.1157 7.98359 13.2757V13.2757C7.57455 13.5221 7.43452 14.0668 7.67071 14.4929V14.4929L7.95477 15.0029C8.06574 15.2113 8.25192 15.3651 8.47213 15.4303C8.69233 15.4954 8.92839 15.4665 9.12808 15.35V15.35C9.32439 15.2308 9.55831 15.1981 9.77787 15.2593C9.99742 15.3204 10.1844 15.4703 10.2973 15.6757C10.3713 15.8055 10.411 15.9534 10.4125 16.1043V16.1043C10.4125 16.599 10.7978 17 11.273 17H11.837C12.3106 17 12.6951 16.6016 12.6974 16.1086V16.1086C12.6963 15.8707 12.7866 15.6422 12.9482 15.4739C13.1098 15.3057 13.3293 15.2117 13.5578 15.2129C13.7025 15.2169 13.8439 15.2581 13.9695 15.3329V15.3329C14.3801 15.5791 14.9046 15.4335 15.1428 15.0071V15.0071L15.4392 14.4929C15.554 14.2878 15.5855 14.0437 15.5267 13.8144C15.468 13.5852 15.3239 13.3897 15.1264 13.2714V13.2714C14.9288 13.1531 14.7847 12.9577 14.726 12.7284C14.6673 12.4992 14.6988 12.255 14.8135 12.05C14.8881 11.9144 14.9961 11.802 15.1264 11.7243V11.7243C15.5335 11.4764 15.673 10.9336 15.4392 10.5071V10.5071V10.5029Z",
    stroke: "#6E7079",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 1,
    stroke: "#6E7079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavSwConfigIcon);
export default __webpack_public_path__ + "static/media/SideNavSwConfigIcon.6c6cb4149addb51dbbb35abee62ff906.svg";
export { ForwardRef as ReactComponent };